//Landing page
import Home from "../pages/Home";

export const publicRoutes = [{ path: "/", component: <Home /> }];
